import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NAVIGATOR_SCREEN_DETAILS, NAVIGATOR_SCREEN_DETAILS_RELEASE, NAVIGATOR_THEME, VIEW_TYPE } from '../../utility/constants';
import { CryptUtilService } from 'src/app/shared/services/crypt-util.service';
import { ProjectSummaryService } from '@projects/projectsummary/src/app/projectsummary/project-summary.service';
import { Subscription } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { IIDRService } from '@projects/iidr/src/app/iidr/iidr.service';
import { MessagingService } from 'src/app/shared/services/messaging.service';
import { BUS_MESSAGE_KEY } from 'src/app/shared/constants/message-bus';
import { UserPreferenceService } from 'src/app/shared/services/user-preferences.service';
import { PsgService } from '@projects/psg/src/app/psg/psg.service';
import { EU_REGION, US_REGION } from '@projects/workspace/src/app/my-projects/utility/constants';
import { environment } from 'src/environments/environment';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CommonDialogueBoxComponent } from 'src/app/shared/components/common-dialogue-box/common-dialogue-box.component';
import { DialogComponent } from '@projects/psg/src/app/shared/dialog/dialog.component';
import { ACCESS_OBJECTS, OBJECT_VALUES, PERMISSIONS, PROJECT_STATUS } from '../../utility/constants';
import { PassGlobalInfoService } from 'src/app/shared/services/pass-project-global-info.service';
import { ProjectGlobalInfoModel } from 'src/app/shared/model/project-global-info.model';
import { UsersDataSharedService } from '@projects/user-management/src/app/user/service/users-data-shared.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { UserPermissionService } from '../../services/user-permission.service';
import { MyProjectsService } from '@projects/workspace/src/app/my-projects/my-projects.service';
export interface ScreenDetail {
  name: string;
  path: string;
  translatedName: string;
}

@Component({
    selector: 'app-quick-navigator',
    templateUrl: './quick.navigator.component.html',
    styleUrls: ['./quick.navigator.component.scss'],
    standalone: false
})
export class QuickNavigatorComponent implements OnInit, OnDestroy {

  @Input() projectId: number;
  masterProjectDataSubscription: Subscription;
  @Input() projectinfo: any;
  @Input() currentScreenName?: string;
  @Input() theme?: string = NAVIGATOR_THEME[0];
  @Output() setProjectInfoData = new EventEmitter();
  @Output() onDeleteProject = new EventEmitter<any>();
  @Input() VIEW =VIEW_TYPE.CARD_VIEW;
  @Input() releaseInfo: any;
  @Input() isNavigatorDisabled=false;
  @Input() isPinnedSection: boolean = false;
  VIEW_TYPE = VIEW_TYPE;
  screenOptions: ScreenDetail[] = NAVIGATOR_SCREEN_DETAILS;
  activityRedirectData;
  projectDetailsSubscription: Subscription;
  subscriptions: Subscription[]= [];
  packageId;
  functionId;
  defaultTheme = NAVIGATOR_THEME[0];
  languageId: number = 1;
  releaseId: number;
  @Input() isMasterproject = false;
  @Input() releaseView = false;
  masterProjId: number;
  featureFlagMultiReleaseEnabled: boolean = false;
  userPermissionObj: any;
  @Input() userData: any;
  ACCESS_OBJECTS = ACCESS_OBJECTS;
  OBJECT_VALUES = OBJECT_VALUES;
  PERMISSIONS = PERMISSIONS;
  PROJECT_STATUS = PROJECT_STATUS;
  projectGlobalInfo: ProjectGlobalInfoModel = new ProjectGlobalInfoModel();
  US_REGION = US_REGION;
  EU_REGION = EU_REGION;
  subscriptionUserPermission: Subscription;
  MY_PROJECTS = 'MY_PROJECTS';
  masterProjectSpecialStyling: boolean = false; // Flag to determine if special styling should be applied for master projects in my-projects with multi-release enabled
  isCurrentUserAdmin: boolean = false;
  resetDraftFeatureflag: boolean = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private cryptUtilService: CryptUtilService,
    private projectSummaryService: ProjectSummaryService,
    private iidrService: IIDRService,
    private messagingBus: MessagingService,
    private userPreference: UserPreferenceService,
    private psgService: PsgService,
    private dialog: MatDialog,
    private globalData: PassGlobalInfoService,
    private usersDataSharedService: UsersDataSharedService,
    private sharedService: SharedService,
    public userPermissionService: UserPermissionService,
    private myProjectsService: MyProjectsService
    ) { }


  ngOnInit(): void {
    this.projectId = this.route.snapshot.queryParams.projectId;
    this.featureFlagMultiReleaseEnabled = (this.cryptUtilService.getItem('commonFeatureFlag', 'LOCAL'))?.multiRelease === 'true';
    this.resetDraftFeatureflag = ((this.cryptUtilService.getItem('commonFeatureFlag', 'LOCAL'))?.auto_on_offboarding_project_creation_enabled === 'true');
    // Parse accessObjects if it's a string for on page load in my projects section:
    if (this.projectinfo && typeof this.projectinfo.accessObjects === 'string') {
      try {
        this.projectinfo.accessObjects = JSON.parse(this.projectinfo.accessObjects);
      } catch (e) {
        console.error(' Failed to parse accessObjects:', e);
      }
    }
    
    // Get user permission data
    this.userPermissionObj = this.sharedService?.getExternalUserData(this.MY_PROJECTS);
    
    this.subscriptionUserPermission = this.sharedService.getUserPermissionDataUpdated().subscribe((data) => {
      if (data) {
        this.userPermissionObj = this.sharedService?.getExternalUserData(this.MY_PROJECTS);
       
      }
    });
    
    this.subscriptions.push(
      this.userPreference.getLanguageId().subscribe((langId) => {
        this.languageId = +langId
      })
    );
    // commented out below code as handling of showing menu items using updateNavigatorOptions() method.
    // if (this.releaseInfo && this.releaseInfo.release_id) {
    //   this.screenOptions = NAVIGATOR_SCREEN_DETAILS_RELEASE;
    // }
    // else if (this.isMasterproject === true) {
    //   this.screenOptions = NAVIGATOR_SCREEN_DETAILS.filter(option => option.name === 'Projects Setup');
    // }
  }

  /**
   * Determines the current screen name based on URL and context (master/release)
   * This ensures the correct menu item is highlighted based on which project type we're in
   */
  private updateCurrentScreenName(): void {
    const currentUrl = this.router.url;
    // master projects dont have release info:
    // using projectinfo input property from parent components (summary-container,iidr-container,psg-header,activities) dynamically based on the component loads
    const isInRelease = this.releaseInfo && this.releaseInfo.release_id && !(this.projectinfo?.isAscendPMO || this.projectinfo?.isAIG);
    
    if (currentUrl.includes('/projectsummary/')) {
      this.currentScreenName = isInRelease ? 'Release Dashboard' : 'Project Dashboard';
    } else if (currentUrl.includes('/psg/general-details/')) {
      this.currentScreenName = isInRelease ? 'Release Setup' : 'Projects Setup';
    } else if (currentUrl.includes('/iidr')) {
      this.currentScreenName = isInRelease ? 'Release Methodology' : 'Project Methodology';
    } else if (currentUrl.includes('/sitemap/')) {
      this.currentScreenName = isInRelease ? 'Release Site Map' : 'Project Site Map';
    } else if (currentUrl.includes('/document-repository/')) {
      this.currentScreenName = isInRelease ? 'Release Documents' : 'Project Documents';
    }
  }

  /**
   * Updates screen options dynamically based on current URL and feature flags
   * This method handles all conditions to ensure correct menu options on every click
   */
  private updateNavigatorOptions(): void {
    // Read flags from local storage
    const isMasterProjectFromStorage = this.cryptUtilService.getItem('isMasterProject', 'LOCAL');
    const featureFlags = this.cryptUtilService.getItem('commonFeatureFlag', 'LOCAL');
    const multiReleaseEnabled = featureFlags?.multiRelease === 'true';
    
    // Check if user is in Scope section by URL
    const currentUrl = this.router.url;
    const isInScopeSection = currentUrl.includes('/additional-scoping-details/scope');
    const isInMyProjectsSection = currentUrl.includes('/my-projects');

    // for My projects screen, using projectinfo input property from card layout component
    if(this.projectinfo?.AIGProject || this.projectinfo?.PMOProject && isInMyProjectsSection && multiReleaseEnabled) {
      this.screenOptions = NAVIGATOR_SCREEN_DETAILS;
      return;
    }

    // Determine which options to show based on current state
    // if release is selected, show release specific options
    if (this.releaseInfo && this.releaseInfo.release_id && multiReleaseEnabled) {
      // For PMO/AIG projects in my projects screen, show project options:
        if (isInMyProjectsSection) {
          this.screenOptions = NAVIGATOR_SCREEN_DETAILS_RELEASE;
          return;
        }
        else {
          // For PMO/AIG projects in other screens show project related options:
          // using projectinfo input property from parent components (summary-container,iidr-container,psg-header,activities) dynamically based on the component loads
          if (this.projectinfo?.isAscendPMO || this.projectinfo?.isAIG) {
            this.screenOptions = NAVIGATOR_SCREEN_DETAILS;
            return;
          }
          else {
            // For release projects (not master), add extra master project navigation options only if multi-release is enabled
            const dashboardOption = NAVIGATOR_SCREEN_DETAILS.find(opt => opt.name === 'Project Dashboard');
            const setupOption = NAVIGATOR_SCREEN_DETAILS.find(opt => opt.name === 'Projects Setup');
            this.screenOptions = [
              ...NAVIGATOR_SCREEN_DETAILS_RELEASE,
              ...(dashboardOption ? [dashboardOption] : []),
              ...(setupOption ? [setupOption] : [])
            ];
          }
        }
    }
    // for scope section of master project with multi-release enabled, show only project dashboard
    else if (isMasterProjectFromStorage === true && 
             multiReleaseEnabled === true && 
             !isInMyProjectsSection) {
      // Show only Project Dashboard for master project in Scope section with multi-release enabled
      this.screenOptions = NAVIGATOR_SCREEN_DETAILS.filter(option => option.name === 'Project Dashboard');
    }
    // for my projects screen of master project, show only project setup
    else if (this.isMasterproject === true && multiReleaseEnabled === true) {
      this.screenOptions = NAVIGATOR_SCREEN_DETAILS.filter(option => option.name === 'Projects Setup' || option.name === 'Project Dashboard');
    }
    else {
      // Default: show all options
      this.screenOptions = NAVIGATOR_SCREEN_DETAILS;
    }
  }

  /**
   * TrackByScreen : Tracks items in a list of screens by their unique path.
   * This method is used to optimize rendering performance by providing
   * a unique identifier for each screen, allowing Angular to efficiently
   * track changes in the list.
   *
   * @param screen - The screen detail object containing information about the screen.
   * @returns The unique path of the screen, used as the tracking identifier.
   */
  trackByScreen = (screen: ScreenDetail): string => screen.path;

  goto(name, path) {
    const featureFlags = this.cryptUtilService.getItem('commonFeatureFlag', 'LOCAL');
    const multiReleaseEnabled = featureFlags?.multiRelease === 'true';

    if(!this.projectId){
      this.projectId = this.projectinfo?.projectId ? this.projectinfo?.projectId : this.router.url.split('/').pop().split('?')[0];
    }
    if (this.releaseInfo && this.releaseInfo.release_id) {
      this.releaseId = this.releaseInfo.release_id;
    }
    switch (name) {
      case "Project Methodology":
      case "Release Methodology":
        // Set flag based on whether we're in release or master or pmo/aig context:
        let isMasterProjectForMethodology = false;
        
        // making isMasterProject to false for release projects:
        if (this.releaseInfo && this.releaseInfo.release_id) {
          this.cryptUtilService.setItem('isMasterProject', false, 'LOCAL');
          isMasterProjectForMethodology = false;
        }
        // making isMasterProject to false for PMO/AIG projects while navigating to methodology:
        // using projectinfo input property from card layout parent component in my projects screen
        // using projectinfo input property from parent components (summary-container,iidr-container,psg-header,activities) dynamically based on the component loads for other screens (for internal navigation)
        else if ((this.projectinfo?.AIGProject || this.projectinfo.isAIG) || (this.projectinfo?.PMOProject || this.projectinfo.isAscendPMO)) {
          this.cryptUtilService.setItem('isMasterProject', false, 'LOCAL');
          isMasterProjectForMethodology = false;
        }
        // making isMasterProject to true for master project while navigating to methodology:
        else {
          this.cryptUtilService.setItem('isMasterProject', true, 'LOCAL');
          isMasterProjectForMethodology = true;
        }
        //this.setSelectedFilterValues(path);
        this.redirectToRespectiveRegion(path, undefined, undefined, isMasterProjectForMethodology);
        break;
      case 'Current Activity':
        this.getCurrentActivity();
        break;
      case 'Project Site Map':
        // For PMO/AIG projects, set isMasterProject to false
        // using projectinfo input property from card layout parent component for my projects screen
        // using projectinfo input property from parent components (summary-container,iidr-container,psg-header,activities) dynamically based on the component loads for other screens (for internal navigation)
        let isMasterProjectForSiteMap = false;
        
        if ((this.projectinfo?.AIGProject || this.projectinfo.isAIG) || (this.projectinfo?.PMOProject || this.projectinfo.isAscendPMO)) {
          this.cryptUtilService.setItem('isMasterProject', false, 'LOCAL');
          isMasterProjectForSiteMap = false;
        }
        // for master projects making isMasterProject to true while navigating to site map:
        else {
          this.cryptUtilService.setItem('isMasterProject', true, 'LOCAL');
          isMasterProjectForSiteMap = true;
        }
        this.redirectToRespectiveRegion(path, this.projectId, undefined, isMasterProjectForSiteMap);
        break;
      case 'Release Site Map':
        this.cryptUtilService.setItem('isMasterProject', false, 'LOCAL');
        this.redirectToRespectiveRegion(path,this.releaseId);
       //this.setPackageFunctionObj(this.projectId);
        break;
      default:

       if(name === "Project Dashboard" && this.projectinfo?.workspaceId && this.projectinfo.workspaceId.trim() !== '')
        {
          window.location.href = `${environment.AIG_URL}/workspaces/project/${this.projectinfo.workspaceId}/tools`;
          return;
        }

        // using projectinfo input property from parent components (summary-container,iidr-container,psg-header,activities) dynamically based on the component loads
        if (multiReleaseEnabled && (name === 'Project Dashboard' || name === 'Projects Setup') && this.releaseInfo && this.releaseInfo.release_id && !(this.projectinfo?.isAscendPMO || this.projectinfo?.isAIG)) {
          // Call API to get master project ID from the release project data
          this.masterProjectDataSubscription = this.psgService.getProjectInfo(this.releaseId, false).subscribe((res) => {
            if (res && res[0] && res[0].masterProjectId) {
              this.masterProjId = res[0].masterProjectId;
              console.log(`Navigating to master project: ${this.masterProjId} from release project: ${this.releaseInfo.release_id}`);
              this.cryptUtilService.setItem('isMasterProject', true, 'LOCAL');
              // Use redirectToRespectiveRegion for region-aware navigation
              this.redirectToRespectiveRegion(path, this.masterProjId);
              this.cryptUtilService.setItem('isMasterProject', true, 'LOCAL');
            }
          });

          return;
        }
        
        // code to navigate from one section to another section in release(if release info) and in master (if no release info).
        // using projectinfo input property from card layout component
        // Check if it's a PMO/AIG project
        const isPMOorAIG = (this.projectinfo?.AIGProject || this.projectinfo?.isAIG) || (this.projectinfo?.PMOProject || this.projectinfo?.isAscendPMO);
        
        // for master projects:
        if (!this.releaseInfo && !isPMOorAIG) {
          this.cryptUtilService.setItem('isMasterProject', true, 'LOCAL');
          this.redirectToRespectiveRegion(path, this.projectId, undefined, true);
        } 
        else {
          // for release projects, redirecting to other screens:
          // pmo/aig projects in psg set up will have release info hence using release id:
          if(this.releaseInfo && this.releaseInfo.release_id )
          {
            // Set isMasterProject flag to false for release (uses v1 APIs)
            this.cryptUtilService.setItem('isMasterProject', false, 'LOCAL');
            // Store the selected release info
            this.cryptUtilService.setItem('selectedRelease', this.releaseInfo, 'SESSION');
            // Extract release ID from releaseInfo
            const releaseId = this.releaseInfo?.release_id;
            if (releaseId) {
              this.cryptUtilService.setItem('projectId', releaseId, 'SESSION');
              this.setProject(this.projectinfo,this.VIEW,releaseId);
            }
            this.redirectToRespectiveRegion(path, this.releaseId, undefined, false);
          }
          // for PMO/AIG projects, using project id instead of release id to navigate
          // in my projects section, for aig/pmo projects no release info wont be there hence using project id
          else if(isPMOorAIG && this.projectinfo?.projectId){
            this.cryptUtilService.setItem('isMasterProject', false, 'LOCAL');
            this.redirectToRespectiveRegion(path, this.projectinfo?.projectId, undefined, false);
          }
        }
        break;
    }
  }

  redirectToRespectiveRegion(path,projectId?,releaseId?,isMasterProject?:boolean) {
    const region = this.projectinfo?.instance_name
    switch (region) {
      case US_REGION:
        if(projectId){
        this.router.navigate([`${path}`+ `${releaseId ? releaseId : projectId}`]);
        }else{
          this.router.navigate([`${path}`],{ queryParams: { projectId: this.releaseId ? this.releaseId : this.projectId } });
         }
        break;
      case EU_REGION:
        if(projectId){
          const isMasterParam = isMasterProject === true ? '?isMasterProject=true' : '';
          window.location.href = `${this.projectinfo?.application_url}${path}${releaseId ? releaseId : projectId}${isMasterParam}`;
        }
        else{
          const projId = encodeURIComponent(this.releaseId ? this.releaseId : this.projectId)
          const isMasterParam = isMasterProject === true ? '&isMasterProject=true' : '';
          window.location.href = `${this.projectinfo?.application_url}/${path}?projectId=${projId}${isMasterParam}`;
        }
        break;
      default:
        if(projectId){
          this.router.navigate([`${path}`+ `${releaseId ? releaseId : projectId}`]);
          }else{
            this.router.navigate([`${path}`],{ queryParams: { projectId: this.releaseId ? this.releaseId : this.projectId } });
           }
    }
  }

  getCurrentActivity() {
    this.cryptUtilService.setItem('CURRENT_ACTIVITY_CLICKED', true, 'SESSION');
    this.prepareActivityURLInputs();
  }

  setSelectedFilterValues(path) {
    this.messagingBus
      .subscribe(BUS_MESSAGE_KEY.USER_DETAILS, (data) => {
        // Security Fix: Removed userid from URL parameters - backend extracts user from JWT token
        let params = new HttpParams();
        this.projectDetailsSubscription = this.projectSummaryService.getProjectInfo(this.projectId, params).subscribe(response => {
          if (response && response[0]?.package_id && response[0]?.functions) {
            let previousSessionIIDRFunctionSelected = this.cryptUtilService.getItem('Previous-Session-Function-Selected-IIDR-Project', 'SESSION');
            if(!previousSessionIIDRFunctionSelected && response?.[0].functions?.length > 0){
              this.cryptUtilService.setItem('Previous-Session-Function-Selected-IIDR-Project', response?.[0].functions?.[0].serviceName , 'SESSION');
            }
          }
           this.router.navigate([`${path}`]);
        })
      })
  }

  prepareActivityURLInputs() {
    this.subscriptions.push(
    this.messagingBus
      .subscribe(BUS_MESSAGE_KEY.USER_DETAILS, (data) => {
        // Security Fix: Removed userid from URL parameters - backend extracts user from JWT token
        let params = new HttpParams();

        const region = this.projectinfo?.instance_name;
        const api_base_url = this.projectinfo?.api_base_url + '/Project/api/v1';
        let api: any;
        switch (region) {
          case US_REGION:
             api = this.projectSummaryService.getProjectInfo(this.projectId, params);
            break;
          case EU_REGION:
            api = this.projectSummaryService.getRespectiveProjectInfo(this.projectId, params, 1, api_base_url);
            break;
          default:
            api = this.projectSummaryService.getProjectInfo(this.projectId, params);
            break;
        }

        this.projectDetailsSubscription = api.subscribe(response => {
          if (response && response[0]?.package_id && response[0]?.functions) {
            let previousSessionIIDRFunctionSelected = this.cryptUtilService.getItem('Previous-Session-Function-Selected-IIDR-Project', 'SESSION');
            if(!previousSessionIIDRFunctionSelected && response?.[0].functions?.length > 0){
              this.cryptUtilService.setItem('Previous-Session-Function-Selected-IIDR-Project', response?.[0].functions?.[0].serviceName , 'SESSION');
            }
            let functionId = response?.[0]?.functions?.find(d=> d.serviceName === previousSessionIIDRFunctionSelected)?.id
            this.functionId = functionId ? functionId : response?.[0].functions?.[0].id;
            this.packageId = response?.[0].package_id;

            this.iidrService
              .getTrainStopDataOnCardLayout(
                this.projectId,
                this.packageId,
                this.functionId,
                api_base_url + '/trainstop'
              ).subscribe((response) => {
                let phaseData = response?.data;
                let activityRedirectURL = '';
                let lastTrainstop = '';
                let initialActivitCall;
                for (const phase of phaseData) {
                  for (const stop of phase?.trainstops) {
                    if (stop?.isactive === "true" && (stop?.stop_status === "incomplete" || !stop?.stop_status)) {
                      activityRedirectURL = `/trainstops/activities/${phase?.phase_name}/${stop?.trainstop_id}`;
                      initialActivitCall = {
                        stopId: stop?.trainstop_id,
                        projectId: this.projectId,
                        packageId: this.packageId,
                        functionId: this.functionId
                      };
                      break;
                    } else {
                      lastTrainstop = `/trainstops/activities/${phase?.phase_name}/${stop?.trainstop_id}`;
                    }
                  }
                  if (activityRedirectURL?.length > 0) break;
                }
                if (activityRedirectURL?.length > 0) {
                  this.redirectToRespectiveRegion(activityRedirectURL);
                } else {
                  if(lastTrainstop?.length > 0) {
                    this.redirectToRespectiveRegion(lastTrainstop);
                  }
                }
              })
          }
        });
      })
      );
  }

 openQuickNavigator(){   
    // Parse accessObjects if it's a string (after filtering projects)
    // using projectinfo input property from card layout parent component
    if (this.projectinfo && typeof this.projectinfo.accessObjects === 'string') {
      try {
        this.projectinfo.accessObjects = JSON.parse(this.projectinfo.accessObjects);
      } catch (e) {
        console.error('Failed to parse accessObjects:', e);
      }
    }
   
    // Check if current user is a project admin when opening the menu
    if (this.projectinfo?.projectId && this.userData?.userId) {
      this.isCurrentUserProjectAdmin(this.projectinfo.projectId, this.userData.userId).then((isAdmin) => {
        this.isCurrentUserAdmin = isAdmin;
      });
    }

    // Check if we're in "my projects" section
    const currentUrl = this.router.url;
    const isInMyProjectsSection = currentUrl.includes('/my-projects');
   
    // Get multi-release feature flag
    const featureFlags = this.cryptUtilService.getItem('commonFeatureFlag', 'LOCAL');
    const multiReleaseEnabled = featureFlags?.multiRelease === 'true';
   
    // Apply special styling only for master projects in my-projects with multi-release enabled
    this.masterProjectSpecialStyling =
      this.isMasterproject === true &&
      multiReleaseEnabled === true &&
      isInMyProjectsSection;
   
    // Update navigator options based on current context
    this.updateNavigatorOptions();
   
    // Update current screen name to ensure correct highlighting only if multi-release is enabled
    //const featureFlags = this.cryptUtilService.getItem('commonFeatureFlag', 'LOCAL');
    //const multiReleaseEnabled = featureFlags?.multiRelease === 'true';
    if (multiReleaseEnabled) {
      this.updateCurrentScreenName();
    }
    this.setProjectInfoData.emit(true);
  }

  setPackageFunctionObj(projectId:any) {
    // Security Fix: Removed userid from URL parameters - backend extracts user from JWT token
    let params = new HttpParams();
    let projectInfo, jiraProjectKey, previousSessionIIDRFunctionSelected;
    this.projectSummaryService.getProjectInfo(projectId, params).subscribe((data: any) => {
      if (data) {
        projectInfo = data[0];
        let temp_obj;
        jiraProjectKey = data[0].jiraProjectKey;
        previousSessionIIDRFunctionSelected = this.cryptUtilService.getItem('Previous-Session-Function-Selected-IIDR-Project', 'SESSION');
      if(previousSessionIIDRFunctionSelected){
        projectInfo?.functions.forEach((item) => {
          if(previousSessionIIDRFunctionSelected.toLowerCase() == item.serviceName.toLowerCase()){
            temp_obj={
             package_id:projectInfo?.package_id,
             function_id:item?.id,
             user_role_id:projectInfo?.user_role_id,
             is_jira_project:projectInfo?.requestJiraInstance,
             function_name:item?.serviceName
           }
         }
        });

      }
      else{
        this.cryptUtilService.setItem('Previous-Session-Function-Selected-IIDR-Project', projectInfo.functions?.[0].serviceName , 'SESSION');
        let func_id;
        // projectInfo?.functions?.some((e, i)=> {
        //   if(e.serviceName == "Core") {
        //     func_id = e.id
        //   }
        // });
        // if(!func_id)
        func_id = projectInfo?.functions[0]?.id

         temp_obj={
          package_id:projectInfo?.package_id,
          function_id:func_id,
          user_role_id:projectInfo?.user_role_id,
          is_jira_project:projectInfo?.requestJiraInstance,
          function_name:projectInfo?.functions[0]?.serviceName
        }
      }
        this.projectSummaryService.package_function_obj.next(temp_obj);
        this.router.navigate(['/sitemap/' + `${this.projectId}`]);
      }
    })
  }

  setProject(projectInfo, viewMode, releaseId?) {
    this.projectGlobalInfo.projectId = projectInfo.projectId;
    this.projectGlobalInfo.viewMode = viewMode;
    this.projectGlobalInfo.uniqueId = projectInfo.userroleId;
    this.projectGlobalInfo.userroleId = projectInfo.userroleId;
    this.projectGlobalInfo.projectName = projectInfo.projectName;
    this.projectGlobalInfo.clientName = projectInfo.clientName;
    this.projectGlobalInfo.clientUrl = projectInfo.clientLogoURL;
    this.projectGlobalInfo.role = projectInfo.projectRole;
    this.projectGlobalInfo.managerName = projectInfo.managerName;
    this.projectGlobalInfo.packageName = projectInfo.erpPackage;
    this.projectGlobalInfo.offerings = projectInfo.offering;
    this.projectGlobalInfo.accessObjects = projectInfo.accessObjects;
    if (releaseId) {
      this.projectGlobalInfo.releaseId = releaseId;
    }
    this.globalData.updateGlobalData(this.projectGlobalInfo);
    this.globalData.setProjectDetails({
      project: projectInfo,
      viewmode: viewMode
    });
    if (this.userData?.userId) {
      this.usersDataSharedService.updateUserRoleAssociation(this.projectGlobalInfo, this.userData.userId, this.globalData)
    }
  }

  goToUsersPage(userType, projectInfo, viewMode) {
    this.setProject(projectInfo, viewMode)
    const region = this.projectinfo?.instance_name;
    let path = region === EU_REGION ? '/workspace/my-projects/manage-project/users/' : 'workspace/my-projects/manage-project/users/';
    // Check if it's a PMO/AIG project
    const isPMOorAIG = this.projectinfo?.AIGProject || this.projectinfo?.PMOProject;
    let isMasterProjectFlag = false;
    
    if (this.releaseInfo && this.releaseInfo.release_id) {
      this.cryptUtilService.setItem('isMasterProject', false, 'LOCAL');
      isMasterProjectFlag = false;
    } 
    // for PMO/AIG projects release info wont be there, making isMasterProject to false:
    else {
      // using projectinfo input proprty from parent component(card-layout)
      if(isPMOorAIG){
        this.cryptUtilService.setItem('isMasterProject', false, 'LOCAL');
        isMasterProjectFlag = false;
      }
      // for master projects
      else{
        this.cryptUtilService.setItem('isMasterProject', true, 'LOCAL');
        isMasterProjectFlag = true;
      }
    }
    this.redirectToRespectiveRegion(path, projectInfo.projectId, undefined, isMasterProjectFlag);
  }

  openRestrictedDeleteDialog(projectInfo, viewMode) {
    this.setProject(projectInfo, viewMode);
    const projectName = this.projectGlobalInfo?.projectName || projectInfo.projectName;
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '600px',
      disableClose: false,
      data: {
        title: 'Delete Project',
        description: 'MultiRelease.MasterProject.Delete.Dialog',
        projectName: projectName,
        primarybutton: 'Global.Common.Button.Confirm',
        seconadarybutton: 'Global.Common.Button.Cancel',
        isCountryRestriction: true
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'true') {
        // Call the delete API with v2 endpoint
        this.softDeleteProjectWithV2(projectInfo);
      }
    });
  }

  softDeleteProjectWithV2(projectInfo: any) {
    // PMO/AIG projects should use v1 API, only true master projects use v2
    const isPMOorAIG = projectInfo?.PMOProject || projectInfo?.AIGProject;
    const apiVersion = isPMOorAIG ? 'v1' : 'v2';
    const api_base_url = projectInfo?.api_base_url + `/Project/api/${apiVersion}`;
    const obj = {
      headers: { 'Content-Type': 'application/json' },
      body: isPMOorAIG
        ? {
            "project_id": projectInfo?.projectId,
            "user_id": this.userData?.userId
          }
        : {
            "master_project_id": projectInfo?.projectId,
            "user_id": this.userData?.userId
          }
    };

    this.myProjectsService.softDeleteProject(obj, api_base_url).subscribe(
      (response) => {
        // After successful delete, emit the event for UI cleanup
        this.onDeleteProject.emit(projectInfo);
      },
      (error) => {
        console.error('Error deleting project:', error);
        // Optionally show error notification
      }
    );
  }

  openDeleteDialog(projectInfo, viewMode) {
    this.setProject(projectInfo, viewMode)
    const isPmoProject = !!(projectInfo?.AIGProject || projectInfo?.PMOProject);
    const useNewPrompt = this.featureFlagMultiReleaseEnabled === true;
    const dialogRef = this.dialog.open(CommonDialogueBoxComponent, {
      data: {
        from: 'PROJECT_SOFT_DELETE',
        title: 'ListProject.Dialog.Delete.Title',
        deleteMessageText: useNewPrompt && !isPmoProject ? 'DeleteProject.PromptContent' : 'ListProject.Dialog.Delete.Message',
        showProjectName: !useNewPrompt || isPmoProject,
        buttonText: 'Global.Common.Dialog.Button.Delete',
        buttonContinueClass: true,
        cancelBtn: useNewPrompt && !isPmoProject ? 'Global.Common.Button.Close' : 'CreateProject.ProjectDetails.Cancel',
        buttonCancelClass: true,
        projectId: this.projectGlobalInfo?.projectId,
        projectName: this.projectGlobalInfo?.projectName,
        userId: this.userData?.userId,
        apiURL: projectInfo?.api_base_url,
      },
      maxWidth: '37vw',
      width: '37vw',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response === 'delete') {
        this.onDeleteProject.emit(projectInfo);
      }
    });
  }

  isCurrentUserProjectAdmin(projectId: number, currentUserEmail: string): Promise<boolean> {
    return new Promise((resolve) => {
      // Check if user is a Platform Admin globally first
      const isPlatformAdmin = this.userPermissionService.userInfo?.englishLanguage?.name?.toLowerCase() === 'platform admin' ||
                              this.userPermissionService.userInfo?.role?.name?.toLowerCase() === 'platform admin';

      // Determine the region and use appropriate API
      const region = this.projectinfo?.instance_name;
      const api_base_url = this.projectinfo?.api_base_url;
      // PMO/AIG projects should use v1 API, only true master projects use v2
      const isPMOorAIG = this.projectinfo?.PMOProject || this.projectinfo?.AIGProject;
      const isMasterForApi = this.isMasterproject && !isPMOorAIG;
      let apiCall: any; // Default to US_REGION if api_base_url is not available for EU_REGION
      if (region === EU_REGION && api_base_url) {
        // For EU projects, use the EU API with region-specific base URL
        apiCall = this.myProjectsService.getRespectiveProjectUsers(projectId, 1, isMasterForApi, api_base_url);
      } else {
        // For US projects, use the default API
        apiCall = this.myProjectsService.getProjectUsers(projectId, 1, isMasterForApi);
      }

      // Fetch project users to check role in this specific project
      apiCall.subscribe(
        (response) => {
          if (response?.data?.[0]?.members) {
            const currentUser = response.data[0].members.find(
              (member: any) => member.userId?.toLowerCase() === currentUserEmail?.toLowerCase()
            );
            
            const projectRole = currentUser?.projectRole?.toLowerCase();

            // If user is explicitly a Project User in this project, deny access even if Platform Admin
            if (projectRole === 'project user') {
              resolve(false);
              return;
            }

            // If user is Project Admin in this project, show delete button
            if (projectRole === 'project admin') {
              resolve(true);
              return;
            }

            // If Platform Admin but NOT in this project's members list, show delete button
            if (isPlatformAdmin) {
              resolve(true);
              return;
            }

            // Otherwise, no permissions
            resolve(false);
          } else {
            // If can't fetch members but user is Platform Admin, show button
            resolve(isPlatformAdmin);
          }
        },
        (error) => {
          // On error, allow if platform admin as a safe fallback
          resolve(isPlatformAdmin);
        }
      );
    });
  }

  goToCreateProjectsPage(){
    // Set isMasterProject flag based on project type before navigating
    const isPMOorAIG = (this.projectinfo?.AIGProject || this.projectinfo?.isAIG) || (this.projectinfo?.PMOProject || this.projectinfo?.isAscendPMO);
    
    if (this.releaseInfo && this.releaseInfo.release_id) {
      // Release project
      this.cryptUtilService.setItem('isMasterProject', false, 'LOCAL');
    } else if (isPMOorAIG) {
      // PMO/AIG project
      this.cryptUtilService.setItem('isMasterProject', false, 'LOCAL');
    } else {
      // Master project
      this.cryptUtilService.setItem('isMasterProject', true, 'LOCAL');
    }
    
    // Determine instance from leadCountry - US leadCountry means US instance, otherwise EU
    const instance = this.projectinfo?.instance_name || 
                     (this.projectinfo?.leadCountry === 'US' ? US_REGION : EU_REGION);
    this.router.navigate(['/create-project'], { queryParams: { projectId: this.projectinfo?.projectId, instance: instance } });
  }

  ngOnDestroy(): void {
    this.projectDetailsSubscription?.unsubscribe();
    this.subscriptionUserPermission?.unsubscribe();
    this.subscriptions?.forEach((sub) => {
      sub.unsubscribe();
    });
  }

}
